module.exports = __webpack_public_path__ + "static/media/violet.5827b751.png";